var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TopMenu'),_c('div',{staticClass:"container-fluid p-0"},[_vm._v(" WIP ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }